import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  min-height: 100vh;
  max-width: 1260px;
  display: flex;
  overflow-x: auto;
  flex-direction: column;

  h1 {
    text-align: left;
    color: #000;
  }

  @media (max-width: 750px) {
    padding: 10px 0;
    h1 {
      text-align: left;
      font-size: 22px;
      margin-bottom: 15px;
    }
  }

  .banner {
    width: 100%;
    max-width: 400px;
    background-color: #f0f0f0;
    margin: 0 20px 20px 0;
    border-radius: 15px;
    padding-top: 30px;

    img {
      width: 100%;
      object-fit: contain;
      background-color: #f6f6f6;
    }

    div {
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: center;

      button {
        border-radius: 25px;
        margin: 0 10px;
      }
    }
  }

  .banners {
    width: 100%;
    display: flex;
    margin-top: 15px;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: flex-start;
  }
`;
